import { useTranslation } from "react-i18next"

const CardRow = ({ title, value, className, unit }: { title: string, value: string | number, className?: string, unit?: string }) => {
    const { t } = useTranslation()
    return (
        <div className={` d-flex gap-3 p-2  ${className}`}>
            <p className="justify-self-start">{t(title)}:</p>
            <span className="justify-self-end">{value} {t(unit || "")}</span>
        </div>
    )
}

export default CardRow